import { Address, AddressInformation, DigiQuoteAddOnCell } from '@frontend/api';
import { QuoteItemDigiQuoteData } from '@frontend/api';

import { notify } from 'utils/reduxUtils';

import { DRAWER_MODES } from '../constants';
import {
  AdditionalCharge,
  Adjustment,
  CardDetails,
  CustomerInfoStep,
  DrawerMode,
  ExtendedAccount,
  ExtendedContact,
  FacilitateOrderFormValues,
  Facility,
  PaymentMethod,
  SelectedOption,
  ShippingAccount,
  ShippingRate,
  ShippingType,
} from './types';

export const types = {
  SET_SEARCH_QUERY:
    'modules/quotes/modals/facilitateOrderDrawer/SET_SEARCH_QUERY',
  SET_LEAD_TIME: 'modules/quotes/modals/facilitateOrderDrawer/SET_LEAD_TIME',
  SET_LEAD_TIME_BULK:
    'modules/quotes/modals/facilitateOrderDrawer/SET_LEAD_TIME_BULK',
  ADDITIONAL_CHARGE_ADD:
    'modules/quotes/modals/facilitatedOrderDrawer/ADDITIONAL_CHARGE_ADD',
  ADDITIONAL_CHARGE_DELETE:
    'modules/quotes/modals/facilitateOrderDrawer/ADDITIONAL_CHARGE_DELETE',
  ADDITIONAL_CHARGE_UPDATE:
    'modules/quotes/modals/facilitateOrderDrawer/ADDITIONAL_CHARGE_UPDATE',
  ADDRESS_VALIDATION_MODAL_CLOSE:
    'modules/quotes/modals/facilitateOrderDrawer/ADDRESS_VALIDATION_MODAL_CLOSE',
  ADDRESS_VALIDATION_MODAL_OPEN:
    'modules/quotes/modals/facilitateOrderDrawer/ADDRESS_VALIDATION_MODAL_OPEN',
  ADJUSTMENT_ADD: 'modules/quotes/modals/facilitateOrderDrawer/ADJUSTMENT_ADD',
  ADJUSTMENT_DELETE:
    'modules/quotes/modals/facilitatedOrderDrawer/ADJUSTMENT_DELETE',
  ADJUSTMENT_UPDATE:
    'modules/quotes/modals/facilitateOrderDrawer/ADJUSTMENT_UPDATE',
  BILLING_ADDRESS_FORM_HIDE:
    'modules/quotes/modals/facilitateOrderDrawer/BILLING_ADDRESS_FORM_HIDE',
  BILLING_ADDRESS_FORM_SHOW:
    'modules/quotes/modals/facilitateOrderDrawer/BILLING_ADDRESS_FORM_SHOW',
  CLOSE_FACILITATE_ORDER_DRAWER:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/CLOSE_FACILITATE_ORDER_DRAWER',
  CREATE_ORDER_ERROR:
    'modules/quotes/modals/facilitateOrderDrawer/CREATE_ORDER_ERROR',
  CREATE_ORDER_REQUEST:
    'modules/quotes/modals/facilitateOrderDrawer/CREATE_ORDER_REQUEST',
  CREATE_ORDER_SUCCESS:
    'modules/quotes/modals/facilitateOrderDrawer/CREATE_ORDER_SUCCESS',
  SHIPPING_ADDRESS_FORM_SHOW:
    'modules/quotes/modals/facilitateOrderDrawer/SHIPPING_ADDRESS_FORM_SHOW',
  SHIPPING_ADDRESS_FORM_HIDE:
    'modules/quotes/modals/facilitateOrderDrawer/SHIPPING_ADDRESS_FORM_HIDE',
  OPEN_FACILITATE_ORDER_DRAWER:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/OPEN_FACILITATE_ORDER_DRAWER',
  OPEN_FACILITATE_ORDER_DRAWER_ERROR:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/OPEN_FACILITATE_ORDER_DRAWER_ERROR',
  RECEIVE_FACILITATE_ORDER_DRAWER_DATA:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/RECEIVE_FACILITATE_ORDER_DRAWER_DATA',
  RECEIVE_INITIAL_VALUES:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/RECEIVE_INITIAL_VALUES',
  SELECT_ADD_ON: 'modules/quotes/modals/facilitateOrderDrawer/SELECT_ADD_ON',
  SELECT_NEWLY_ADDED_SHIPPING_ADDRESS_INFORMATION:
    'modules/quotes/modals/facilitateOrderDrawer/SELECT_NEWLY_ADDED_SHIPPING_ADDRESS_INFORMATION',
  SELECT_NEWLY_ADDED_BILLING_ADDRESS_INFORMATION:
    'modules/quotes/modals/facilitateOrderDrawer/SELECT_NEWLY_ADDED_BILLING_ADDRESS_INFORMATION',
  SELECT_NEWLY_ADDED_BILLING_ADDRESS_ERROR:
    'modules/quotes/modals/facilitateOrderDrawer/SELECT_NEWLY_ADDED_BILLING_ADDRESS_ERROR',
  SELECT_NEWLY_ADDED_BILLING_ADDRESS_REQUEST:
    'modules/quotes/modals/facilitateOrderDrawer/SELECT_NEWLY_ADDED_BILLING_ADDRESS_REQUEST',
  SELECT_NEWLY_ADDED_BILLING_ADDRESS_SUCCESS:
    'modules/quotes/modals/facilitateOrderDrawer/SELECT_NEWLY_ADDED_BILLING_ADDRESS_SUCCESS',
  SELECT_NEWLY_ADDED_FACILITY_ERROR:
    'modules/quotes/modals/facilitateOrderDrawer/SELECT_NEWLY_ADDED_FACILITY_ERROR',
  SELECT_NEWLY_ADDED_FACILITY_REQUEST:
    'modules/quotes/modals/facilitateOrderDrawer/SELECT_NEWLY_ADDED_FACILITY_REQUEST',
  SELECT_NEWLY_ADDED_FACILITY_SUCCESS:
    'modules/quotes/modals/facilitateOrderDrawer/SELECT_NEWLY_ADDED_FACILITY_SUCCESS',
  SELECT_OPTION:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/SELECT_OPTION',
  BULK_SELECT_OPTION:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/BULK_SELECT_OPTION',
  SET_BILLING_INFORMATION:
    'modules/quotes/modals/facilitateOrderDrawer/SET_BILLING_INFORMATION',
  SET_BILLING_ADDRESS:
    'modules/quotes/modals/facilitateOrderDrawer/SET_BILLING_ADDRESS',
  SET_CARD_DETAILS:
    'modules/quotes/modals/facilitateOrderDrawer/SET_CARD_DETAILS',
  SET_CONTACT_INFO:
    'modules/quotes/modals/facilitateOrderDrawer/SET_CONTACT_INFO',
  SET_CUSTOMER_INFO_STEP:
    'modules/quotes/modals/facilitateOrderDrawer/SET_CUSTOMER_INFO_STEP',
  SET_CUSTOMER_SHIPPING_ACCOUNT_CARRIER:
    'modules/quotes/modals/facilitateOrderDrawer/SET_CUSTOMER_SHIPPING_ACCOUNT_CARRIER',
  SET_CUSTOMER_SHIPPING_ACCOUNT_GROUPING:
    'modules/quotes/modals/faciliateOrderDrawer/SET_CUSTOMER_SHIPPING_ACCOUNT_GROUPING',
  SET_CUSTOMER_SHIPPING_ACCOUNT_METHOD:
    'modules/quotes/modals/facilitateOrderDrawer/SET_CUSTOMER_SHIPPING_ACCOUNT_METHOD',
  SET_CUSTOMER_SHIPPING_ACCOUNT_NUMBER:
    'modules/quotes/modals/facilitateOrderDrawer/SET_CUSTOMER_SHIPPING',
  SET_DELIVERY_OPTION:
    'modules/quotes/modals/facilitateOrderDrawer/SET_DELIVERY_OPTION',
  SET_EDIT_BILLING_ADDRESS:
    'modules/quotes/modals/facilitateOrderDrawer/SET_EDIT_BILLING_ADDRESS',
  SET_EDIT_SHIPPING_ADDRESS:
    'modules/quotes/modals/facilitateOrderDrawer/SET_EDIT_SHIPPING_ADDRESS',
  SET_EXPANDED_CUSTOMER_INFO_STEP_INDICES:
    'modules/quotes/modals/facilitateOrderDrawer/SET_EXPANDED_CUSTOMER_INFO_STEP_INDICES',
  SET_FACILITY: 'modules/quotes/modals/facilitateOrderDrawer/SET_FACILITY',
  SET_OPTIONS_REQUEST:
    'modules/quotes/modals/facilitateOrderDrawer/SET_OPTIONS_REQUEST',
  SET_OPTIONS_SUCCESS:
    'modules/quotes/modals/facilitateOrderDrawer/SET_OPTIONS_SUCCESS',
  SET_PAYMENT_METHOD_OLD:
    'modules/quotes/modals/facilitateOrderDrawer/SET_PAYMENT_METHOD_OLD',
  SET_PAYMENT_METHOD:
    'modules/quotes/modals/facilitateOrderDrawer/SET_PAYMENT_METHOD',
  SET_POINT_OF_CONTACT:
    'modules/quotes/modals/facilitateOrderDrawer/SET_POINT_OF_CONTACT',
  SET_PURCHASE_ORDER_NUMBER:
    'modules/quotes/modals/facilitateOrderDrawer/SET_PURCHASE_ORDER_NUMBER',
  SET_PURCHASE_ORDER_FILE:
    'modules/quotes/modals/facilitateOrderDrawer/SET_PURCHASE_ORDER_FILE',
  SET_SHIPPING_CHOICE:
    'modules/quotes/modals/facilitateOrderDrawer/SET_SHIPPING_CHOICE',
  SET_SHIPPING_INFORMATION:
    'modules/quotes/modals/facilitateOrderDrawer/SET_SHIPPING_INFORMATION',
  SET_SHIPPING_RATE:
    'modules/quotes/modals/facilitateOrderDrawer/SET_SHIPPING_RATE',
  SET_SHIPPING_TYPE:
    'modules/quotes/modals/facilitateOrderDrawer/SET_SHIPPING_TYPE',
  SET_SUPPLIER_FACILITY_ID:
    'modules/quotes/modals/facilitateOrderDrawer/SET_SUPPLIER_FACILITY_ID',
  SET_TAB:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/SET_TAB',
  SET_USE_SHIPPING_ADDRESS:
    'modules/quotes/modals/facilitatedOrderDrawer/SET_USE_SHIPPING_ADDRESS',
  SET_WITH_CONFIRMATION:
    'modules/quotes/modals/facilitateOrderDrawer/SET_WITH_CONFIRMATION',
  SHIPPING_INFO_REQUEST:
    'modules/quotes/modals/facilitateOrderDrawer/SHIPPING_INFO_REQUEST',
  SHIPPING_INFO_SUCCESS:
    'modules/quotes/modals/facilitateOrderDrawer/SHIPPING_INFO_SUCCESS',
  VALIDATE_ADDRESS_ERROR:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/VALIDATE_ADDRESS_ERROR',
  VALIDATE_ADDRESS_REQUEST:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/VALIDATE_ADDRESS_REQUEST',
  VALIDATE_ADDRESS_SUCCESS:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/VALIDATE_ADDRESS_SUCCESS',
  VALIDATE_CC_ERROR:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/VALIDATE_CC_ERROR',
  VALIDATE_CC_REQUEST:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/VALIDATE_CC_REQUEST',
  VALIDATE_CC_SUCCESS:
    'modules/quotes/quoteDetailsPage/modals/facilitateOrderDrawer/VALIDATE_CC_SUCCESS',
} as const;

export const facilitateOrderDrawer = {
  open: (drawerMode: DrawerMode = DRAWER_MODES.CREATE) => ({
    type: types.OPEN_FACILITATE_ORDER_DRAWER,
    payload: { drawerMode },
  }),
  close: () => ({
    type: types.CLOSE_FACILITATE_ORDER_DRAWER,
  }),
  error: notify(
    (payload: { title: string; message: string }) => ({
      type: types.OPEN_FACILITATE_ORDER_DRAWER_ERROR,
      payload,
    }),
    "Can't facilitate order",
  ),
};

export const receiveFacilitateOrderDrawerData = (payload: {
  account?: ExtendedAccount;
  contact?: ExtendedContact;
  isQuoteReadOnly: boolean;
  maxSupplierFacilities: number;
  quoteItems: QuoteItemDigiQuoteData[];
  supplierFacilities: {
    id: number;
    name: string;
  }[];
  supplierFacilityId: number;
  withConfirmation?: boolean;
}) => ({
  type: types.RECEIVE_FACILITATE_ORDER_DRAWER_DATA,
  payload,
});

export const receiveInitialValues = (payload: FacilitateOrderFormValues) => ({
  type: types.RECEIVE_INITIAL_VALUES,
  payload,
});

export const selectOption = (
  payload: (SelectedOption | NonNullable<unknown>) & {
    quoteItemId: number;
  },
) => ({
  type: types.SELECT_OPTION,
  payload,
});

export const bulkSelectOption = (payload: Record<number, SelectedOption>) => ({
  type: types.BULK_SELECT_OPTION,
  payload,
});

export const setDrawerTab = (payload: { tab: string }) => ({
  type: types.SET_TAB,
  payload,
});

export const validateCC = {
  request: () => ({
    type: types.VALIDATE_CC_REQUEST,
  }),
  success: () => ({
    type: types.VALIDATE_CC_SUCCESS,
  }),
  error: () => ({
    type: types.VALIDATE_CC_ERROR,
  }),
};

export const addressValidationModal = {
  open: (payload: {
    originalAddress: Address;
    suggestedAddresses: Array<{ address: Address; score: number }>;
  }) => ({
    type: types.ADDRESS_VALIDATION_MODAL_OPEN,
    payload,
  }),
  close: () => ({
    type: types.ADDRESS_VALIDATION_MODAL_CLOSE,
  }),
};

export const setFacility = (payload: {
  facility: Facility;
  isEditing: boolean;
}) => ({
  type: types.SET_FACILITY,
  payload,
});

export const setShippingInformation = (
  shippingInformation: AddressInformation | null,
) => ({
  type: types.SET_SHIPPING_INFORMATION,
  payload: { shippingInformation },
});

export const setBillingInformation = (
  billingInformation: AddressInformation | null,
) => ({
  type: types.SET_BILLING_INFORMATION,
  payload: { billingInformation },
});

export const setBillingAddress = (payload: { billingAddress: Address }) => ({
  type: types.SET_BILLING_ADDRESS,
  payload,
});

export const setCustomerInfoStep = (payload: { step: CustomerInfoStep }) => ({
  type: types.SET_CUSTOMER_INFO_STEP,
  payload,
});

export const shippingInfo = {
  request: () => ({
    type: types.SHIPPING_INFO_REQUEST,
  }),
  success: (payload: { shipsOn: string; canEstimateShipping: boolean }) => ({
    type: types.SHIPPING_INFO_SUCCESS,
    payload,
  }),
};

export const setShippingType = (payload: { shippingType?: ShippingType }) => ({
  type: types.SET_SHIPPING_TYPE,
  payload,
});

export const setSupplierFacilityId = (payload: {
  supplierFacilityId: number;
}) => ({
  type: types.SET_SUPPLIER_FACILITY_ID,
  payload,
});

export const setShippingChoice = (payload: {
  shippingAccount?: ShippingAccount;
  shippingRate?: ShippingRate;
  shippingType?: ShippingType;
}) => ({
  type: types.SET_SHIPPING_CHOICE,
  payload,
});

export const setShippingRate = (payload: { shippingRate?: ShippingRate }) => ({
  type: types.SET_SHIPPING_RATE,
  payload,
});

export const selectAddOn = (payload: {
  addOn: DigiQuoteAddOnCell;
  quoteItemId: number;
}) => ({
  type: types.SELECT_ADD_ON,
  payload,
});

export const setLeadTime = (payload: {
  quoteItemId: number;
  leadTime: number | null;
  shipsOn: string | null;
  quantityId: number;
  expediteId?: number;
}) => ({
  type: types.SET_LEAD_TIME,
  payload,
});

export const setLeadTimeBulk = (payload: {
  leadTime: number | null;
  shipsOn: string | null;
}) => ({
  type: types.SET_LEAD_TIME_BULK,
  payload,
});

export const adjustments = {
  add: (payload: { quoteItemId: number }) => ({
    type: types.ADJUSTMENT_ADD,
    payload,
  }),
  delete: (payload: { quoteItemId: number; adjustmentId: string }) => ({
    type: types.ADJUSTMENT_DELETE,
    payload,
  }),
  update: (payload: { quoteItemId: number; data: Partial<Adjustment> }) => ({
    type: types.ADJUSTMENT_UPDATE,
    payload,
  }),
};

export const additionalCharges = {
  add: (payload: { quoteItemId: number; additionalChargeId: string }) => ({
    type: types.ADDITIONAL_CHARGE_ADD,
    payload,
  }),
  delete: (payload: { quoteItemId: number; additionalChargeId: string }) => ({
    type: types.ADDITIONAL_CHARGE_DELETE,
    payload,
  }),
  update: (payload: {
    quoteItemId: number;
    additionalChargeId: string;
    data: Partial<AdditionalCharge>;
  }) => ({
    type: types.ADDITIONAL_CHARGE_UPDATE,
    payload,
  }),
};

export const setOptions = {
  request: () => ({
    type: types.SET_OPTIONS_REQUEST,
  }),
  success: (payload: { quoteItems?: QuoteItemDigiQuoteData[] } = {}) => ({
    type: types.SET_OPTIONS_SUCCESS,
    payload,
  }),
};

export const createOrder = {
  request: () => ({
    type: types.CREATE_ORDER_REQUEST,
  }),
  success: () => ({
    type: types.CREATE_ORDER_SUCCESS,
  }),
  error: notify(
    (payload: { title: string; message: string }) => ({
      type: types.CREATE_ORDER_ERROR,
      payload,
    }),
    (action) => action.payload.title,
    (action) => action.payload.message,
  ),
};

export const setCardDetails = (payload: {
  card?: CardDetails;
  stripeToken?: string;
}) => ({
  type: types.SET_CARD_DETAILS,
  payload,
});

export const setPointOfContact = (payload: {
  pointOfContact: string | undefined;
  confirmationEmail: string | undefined;
  withConfirmation: boolean;
}) => ({
  type: types.SET_POINT_OF_CONTACT,
  payload,
});

export const setPaymentMethodOld = (payload: {
  paymentMethod: PaymentMethod;
  confirmPaymentTerms: boolean;
  purchaseOrderNumber?: string;
  purchaseOrderFile?: File;
}) => ({
  type: types.SET_PAYMENT_METHOD_OLD,
  payload,
});

export const setPaymentMethod = (paymentMethod: PaymentMethod) => ({
  type: types.SET_PAYMENT_METHOD,
  payload: { paymentMethod },
});

export const setPurchaseOrderNumber = (purchaseOrderNumber?: string) => ({
  type: types.SET_PURCHASE_ORDER_NUMBER,
  payload: { purchaseOrderNumber },
});

export const setPurchaseOrderFile = (purchaseOrderFile?: File) => ({
  type: types.SET_PURCHASE_ORDER_FILE,
  payload: { purchaseOrderFile },
});

export const setUseShippingAddress = (payload: {
  useShippingAddress: boolean;
}) => ({
  type: types.SET_USE_SHIPPING_ADDRESS,
  payload,
});

export const selectNewlyAddedBillingAddress = {
  error: notify(
    (error: Error) => ({
      type: types.SELECT_NEWLY_ADDED_BILLING_ADDRESS_ERROR,
      payload: error,
    }),
    'Error selecting new billing address',
  ),
  success: (payload: { billingAddress: Address }) => ({
    type: types.SELECT_NEWLY_ADDED_BILLING_ADDRESS_SUCCESS,
    payload,
  }),
};

export const selectNewlyAddedBillingAddressInformation = (payload: {
  address: Address;
}) => ({
  type: types.SELECT_NEWLY_ADDED_BILLING_ADDRESS_INFORMATION,
  payload,
});

export const selectNewlyAddedShippingAddressInformation = (payload: {
  address: Address;
}) => ({
  type: types.SELECT_NEWLY_ADDED_SHIPPING_ADDRESS_INFORMATION,
  payload,
});

export const selectNewlyAddedFacility = {
  error: notify(
    (error: Error) => ({
      type: types.SELECT_NEWLY_ADDED_FACILITY_ERROR,
      payload: error,
    }),
    'Error selecting new facility',
  ),
  success: (payload: { facility: Facility }) => ({
    type: types.SELECT_NEWLY_ADDED_FACILITY_SUCCESS,
    payload,
  }),
};

export const billingAddressForm = {
  show: () => ({
    type: types.BILLING_ADDRESS_FORM_SHOW,
  }),
  hide: () => ({
    type: types.BILLING_ADDRESS_FORM_HIDE,
  }),
};

export const shippingAddressForm = {
  show: () => ({
    type: types.SHIPPING_ADDRESS_FORM_SHOW,
  }),
  hide: () => ({
    type: types.SHIPPING_ADDRESS_FORM_HIDE,
  }),
};

export const setEditBillingAddress = (payload: { address: Address }) => ({
  type: types.SET_EDIT_BILLING_ADDRESS,
  payload,
});

export const setEditShippingAddress = (payload: { address: Address }) => ({
  type: types.SET_EDIT_SHIPPING_ADDRESS,
  payload,
});

export const setSearchQuery = (payload: { searchQuery: string }) => ({
  type: types.SET_SEARCH_QUERY,
  payload,
});

export const setExpandedCustomerInfoStepIndices = (payload: {
  expandedCustomerInfoStepIndices: number[];
}) => ({
  type: types.SET_EXPANDED_CUSTOMER_INFO_STEP_INDICES,
  payload,
});
